import React from 'react'
import styled from 'styled-components'

const ResourceWrapper = styled.div<{ whiteBg?: boolean; border?: boolean }>`
  height: 79px;
  width: 100%;
  padding: 1rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border-radius: 6px;
  border: ${(props) => (props.border ? `1px solid #fff` : `none`)};
  margin-top: 10px;
  ${(props) => (props.onClick ? 'cursor: pointer;' : '')}
  ${(props) =>
    props.whiteBg ? 'background: #FFF;  color: var(--primary);' : null}
`

const ResourceText = styled.p`
  margin: 0;
  padding: 0;
  font-weight: 500;
  color: inherit;
`
const ResourceIconContainer = styled.div<{ whiteBg?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  height: 39px;
  width: 43px;
  margin-right: 22px;
  ${(props) =>
    props.whiteBg ? 'background-color: rgba(0, 64, 109, 0.15);' : ''}
`

const ResourceIcon = styled.i`
  font-size: 24px;
  color: inherit;
  height: 24px;
  width: 24px;
`

export const CheckIconContainer = styled.div`
  border-radius: 50%;
  background-color: #7dd491;
  color: #fff;
  height: 1.5rem;
  width: 1.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 1rem;
`

interface ResourceProps {
  whiteBg?: boolean
  icon: string
  title: string
  subtitle?: string
  onClick?: any
  [x: string]: any
}

export const Resource: React.FC<ResourceProps> = ({
  whiteBg,
  icon,
  title,
  subtitle,
  onClick,
  ...p
}) => {
  return (
    <ResourceWrapper whiteBg={whiteBg} {...p} onClick={onClick}>
      {icon === 'icon-correct' ? (
        <CheckIconContainer>
          <i className="icon icon-correct fs-14 font-weight-bold"></i>
        </CheckIconContainer>
      ) : (
        <ResourceIconContainer whiteBg={whiteBg}>
          <ResourceIcon className={`icon ${icon}`} />
        </ResourceIconContainer>
      )}

      <div className="d-flex flex-column">
        <ResourceText className="fs-18">{title}</ResourceText>
        <ResourceText className="fs-12">{subtitle}</ResourceText>
      </div>
    </ResourceWrapper>
  )
}
